{
  "Appointment": "Appointment",
  "snapshotFields": {
    "status": "Status",
    "subject": "Subject",
    "startTime": "Start Time",
    "endTime": "End Time",
    "isAllDay": "All Day",
    "isBlock": "Blocked Interval",
    "startTimezone": "Start Time Zone",
    "endTimezone": "End Time Zone",
    "description": "Description",
    "isReadOnly": "Read Only",
    "recurrence": "Recurrence",
    "cancelationReason": "Cancellation Reason",
    "cancelationReasonDetails": "Cancellation Details",
    "cancellationReason": "Cancellation Reason",
    "canceledAt": "Canceled At",
    "canceledBy": "Canceled By",
    "rescheduledFromAppointment": "Rescheduled From (Appointment ID)",
    "rescheduledToAppointment": "Rescheduled To (Appointment ID)",
    "department": "Department",
    "location": "Location",
    "company": "Company",
    "patient": "Patient",
    "employee": "Medical Staff",
    "partnerEmployee": "Referring Doctor",
    "patientSheetType": "Patient Sheet Type",
    "patientSheet": "Patient Sheet",
    "competency": "Competency",
    "competencies": "Competencies",
    "rooms": "Rooms",
    "equipments": "Equipment",
    "source": "Source",
    "notifications": "Notifications",
    "sms": "SMS",
    "isActive": "Active",
    "confirmationMessage": "Confirmation Message",
    "reminderMessage": "Reminder Message",
    "reminderQueueIds": "Reminder Queue",
    "emailIds": "Emails",
    "smsIds": "SMS Messages",
    "messageBody": "Message",
    "firstName": "First Name",
    "lastName": "Last Name",
    "professionalTitle": "Professional Title",
    "phone": "Phone",
    "phonePrefix": "Phone Prefix",
    "email": "Email",
    "idNumber": "PID/CNP",
    "gender": "Gender",
    "parafaCode": "Stamp Code",
    "name": "Name",
    "code": "Code",
    "module": "Module",
    "kind": "Kind",
    "reference": "Reference",
    "details": "Details",
    "rule": "Rule",
    "exception": "Exception",
    "first": "First Occurrence"
  }
}
